import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

const { Get, Post, Put, Delete } = axiosInstanceApiGateway

export type ThresholdType = {
  id: number
  location_id: number
  factor_type: string
  min_threshold: number
  max_threshold: number
  additional_sla_minutes: number
  updated_at: number
  updated_by: string
}

export type GetThresholdsResponseType = {
  thresholds: ThresholdType[]
}

export type CreateThresholdPayloadType = {
  location_id: number
  factor_type: string
  min_threshold: number
  max_threshold: number
  additional_sla_minutes: number
}

export type UpdateThresholdPayloadType = {
  min_threshold: number
  max_threshold: number
  additional_sla_minutes: number
}

export const getThresholds = (params: { location_id: number; factor_type: string }) =>
  Get<GetThresholdsResponseType, true>({
    url: '/fulfillment/internal/v1/additional-sla/thresholds',
    params,
  })

export const createThreshold = (data: CreateThresholdPayloadType) =>
  Post({ url: '/fulfillment/internal/v1/additional-sla/thresholds', data })

export const updateThreshold = (id: number, data: UpdateThresholdPayloadType) =>
  Put({ url: `/fulfillment/internal/v1/additional-sla/thresholds/${id}`, data })

export const deleteThreshold = (id: number) =>
  Delete({ url: `/fulfillment/internal/v1/additional-sla/thresholds/${id}` })
